export enum NavigationSource {
    Default = 0,
    ArrowNext = 1,
    ArrowPrev = 2,
    Breadcrumb = 3,
    LinkedWindow = 4,
    Self = 5,
    SearchResults = 6,
    Favorite = 7,
    Tab = 8,
    ContextualNavDrawer = 9
};
